export const types = {
  GET_ROOT_ORGANIZATION: 'organizationDetails',
  GET_PARTICIPANT_DETAILS: 'participantDetails',
  GET_UNREAD_COUNT_DETAILS: 'chatUnreadCountDetails',
  RESET_UNREAD_COUNT_DETAILS: 'resetUnReadCountDetails'
};
